import React, { useEffect, useState } from 'react';

const Loader = () => {
  const [msg, setMsg] = useState('Loading...');
  useEffect(() => {
    setTimeout(() => {
      setMsg('Connecting server...');
    }, 3000);
    setTimeout(() => {
      setMsg('Connecting to Cai...');
    }, 10000);
  }, []);
  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#222',
        color: 'white',
      }}>
      <div>{msg}</div>
    </div>
  );
};

export default Loader;
